import NamedDto from 'modules/base/dto/NamedDto';

export class OutlierDetectorEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;

		/** @type {number} */
		this.version = null;

		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _OutlierDetectorEditDtoProps
	 * @property {string} type
	 * @property {number} version
	 * @property {number} userGroup	
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OutlierDetectorEditDtoProps} OutlierDetectorEditDtoProps
	 */
	/**
	 *
	 * @param {OutlierDetectorEditDtoProps} props
	 * @returns {OutlierDetectorEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.version = props.version;
		this.userGroup = props.userGroup;

		return this;
	}
}

export default OutlierDetectorEditDto;